import React, { useMemo } from "react";
import Loader from "../../../components/Loader";
import { Link, useLocation } from "react-router-dom";
import InnerBannerBreadcrumb from "../../../components/shared/breadcrumb/InnerBannerBreadcrumb";
import {
  convertStringToArray,
  convertSymbolCodes,
  extractDate,
  extractDateFromStr,
  getLatestUpdatedObject,
} from "../../../Utils/utils";
import { useLanguageTranslation } from "../../../hooks/useLanguageTranslation";
import { useSelector } from "react-redux";
import { useGetProtectedApiDataQuery } from "../../../redux/services/apiSlice";
import PageLastUpdated from "../../../components/shared/PageLastUpdated";
import { useTableResponsive } from "../../../hooks/useTableResponsive";
import PdfZipItem from "../../../components/PdfZipItem";
import useSeo from "../../../hooks/useSeo";

const Awards = () => {
  const { languageType } = useSelector((state) => state.homeSlice);
  const { getText } = useLanguageTranslation();
  const { data: awardsData = [], isLoading: awardsIsLoading } =
    useGetProtectedApiDataQuery({
      url: "awards_and_accreditation",
      lang: languageType,
    });
  const { pathname } = useLocation();
  const { innerBannerImage, innerBannerTitle } = useSeo({ pathname });
  const lastUpdatedOn = useMemo(() => {
    return extractDateFromStr(getLatestUpdatedObject(awardsData)?.changed);
  }, [awardsData]);

  useTableResponsive(awardsData);

  // introduction api data
  const introductionHtml = awardsData.find((item) => item.nid === "697");

  // Various Awards Received
  const variousAwardsReceivedObj = awardsData.find(
    (item) => item.nid === "702"
  );

  // Various Accreditation Received
  const variousAccreditationReceivedObj = awardsData?.find(
    (item) => item.nid === "700"
  );
  const accreditationArray = convertStringToArray(
    variousAccreditationReceivedObj?.field_download
  );

  // awards conferred
  const awardsConferred = awardsData.filter(
    (item) => item.nid !== "697" && item.nid !== "702" && item.nid !== "700"
  );

  if (awardsIsLoading) {
    return <Loader />;
  }
  return (
    <>
      <InnerBannerBreadcrumb
        bannerImage={innerBannerImage}
        title={convertSymbolCodes(innerBannerTitle)}
        isActive={convertSymbolCodes(innerBannerTitle)}
        titleLink="/awards"
        levelTwo={false}
        levelThree={false}
      />

      <div className="inner-container">
        <div className="container">
          <PageLastUpdated lastUpdatedOn={lastUpdatedOn} />

          <div className="row">
            {/* introduction */}
            <div className="col-12 col-sm-12 col-md-12 col-lg-12">
              <div className="title4">
                <h2>{introductionHtml.title}</h2>
              </div>
              <div
                dangerouslySetInnerHTML={{ __html: introductionHtml.body }}
              ></div>
            </div>

            {/* accredition  */}
            <div className="col-12 col-sm-12 col-md-12 col-lg-12 table-awards">
              <div className="title-sec">
                <h2>{variousAccreditationReceivedObj.title}</h2>
                <div className="table-responsive mb-5">
                  <table className="table table-striped custom-table">
                    <thead className="thead-dark">
                      <tr>
                        <th>{getText("S.No.", "क्र. सं.")}</th>
                        <th>{getText("Description", "विवरण")}</th>
                        <th>{getText("Download", "डाउनलोड")}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {accreditationArray.map((item, index) => (
                        <tr key={index}>
                          <td data-key={getText("S.No.", "क्र. सं.")}>
                            {index + 1}
                          </td>
                          <td data-key={getText("Description", "विवरण")}>
                            {item.title}
                          </td>
                          <td data-key={getText("Download", "डाउनलोड")}>
                            <PdfZipItem
                              filePath={item?.file_path}
                              filesize={item?.filesize}
                            />
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            {/* awards */}
            <div className="col-12 col-sm-12 col-md-2 col-lg-12">
              <div className="title-sec">
                <h2>{variousAwardsReceivedObj.title}</h2>
              </div>
              <div
                dangerouslySetInnerHTML={{
                  __html: variousAwardsReceivedObj.body,
                }}
              ></div>
            </div>
            {/* remaining awards */}
            <div className="col-12 col-sm-12 col-md-2 col-lg-12 mt-4">
              <div className="title-sec">
                <h2>
                  {getText("Awards Conferred During", "पुरस्कार प्रदत्त")}
                </h2>
                <div className="table-responsive mb-5">
                  <table className="table table-striped custom-table">
                    <thead className="thead-dark">
                      <tr>
                        <th>{getText("S.No.", "क्र. सं.")}</th>
                        <th>{getText("Description", "विवरण")}</th>
                        <th>{getText("Download", "डाउनलोड")}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {awardsConferred.map((item, index) => (
                        <tr key={index}>
                          <td data-key={getText("S.No.", "क्र. सं.")}>
                            {index + 1}
                          </td>
                          <td data-key={getText("Description", "विवरण")}>
                            {item.title}
                          </td>
                          <td data-key={getText("Download", "डाउनलोड")}>
                            {item.field_download ? (
                              <PdfZipItem
                                filePath={item?.field_download}
                                filesize={item?.filesize}
                              />
                            ) : (
                              <Link
                                to={`/awards/${item.nid}`}
                                className="division-pdf-icon"
                              >
                                <span className="date">
                                  {getText("More", "अधिक")}
                                </span>
                              </Link>
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Awards;
